import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Utility class that provides useful utility functions for Internationalization.
 * @namespace
 */

var IntlUtils = /*#__PURE__*/function () {
  function IntlUtils() {
    _classCallCheck(this, IntlUtils);
  }

  _createClass(IntlUtils, null, [{
    key: "formatDate",

    /**
     * Centralizes calls to Intl.DateTimeFormat to allow for an environmental default for the
     * regional locale used to format the date.
     *
     * @static
     * @param {Date} date input date
     * @param {Object} options options object
     * @param {Object} [locales = process.env.REACT_APP_INTL_LOCALE] optional
     * locale which defaults to the environment value of
     * process.env.REACT_APP_INTL_LOCALE
     * @param {boolean} convertToUTCDate Indicates if the pre-formatted date
     * should be converted into Coordinated Universal Time (UTC).
     *
     * @returns formatted date as per parameters
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
     * @memberof IntlUtils
     */
    value: function formatDate(date, options) {
      var _context, _context2, _context3, _context4, _context5;

      var locales = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.REACT_APP_INTL_LOCALE;
      var convertToUTCDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var dateToDisplay = convertToUTCDate ? IntlUtils.convertToUTCDate(date) : date;
      var dayNumber = dateToDisplay.getDate();
      /* eslint-disable-next-line radix */

      var monthNumber = _parseInt(dateToDisplay.getMonth() + 1);

      var year = dateToDisplay.getFullYear();
      var month = monthNumber.toString().length === 2 ? monthNumber : _concatInstanceProperty(_context = "0").call(_context, monthNumber);
      var day = dayNumber.toString().length === 2 ? dayNumber : _concatInstanceProperty(_context2 = "0").call(_context2, dayNumber);

      var optionsWithTZ = _Object$assign({
        timeZone: 'UTC'
      }, options);

      return new Intl.DateTimeFormat(locales, optionsWithTZ).format(new Date(_concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "").call(_context5, year, "-")).call(_context4, month, "-")).call(_context3, day)));
    }
    /**
     * Converts a date from ISO format to UTC format in order to negate timezone * offset differences.
     * @param {*} date The date in ISO format
     * @private
     */

  }, {
    key: "convertToUTCDate",
    value: function convertToUTCDate(date) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    }
    /**
     * Centralizes calls to Intl.NumberFormat to allow for an environmental default for the
     * regional locale used to format the number.
     *
     * @static
     * @param {number} number input number
     * @param {Object} options options object
     * @param {Object} [locales = process.env.REACT_APP_INTL_LOCALE] optional locale which
     * defaults to the environment value of process.env.REACT_APP_INTL_LOCALE
     *
     * @returns formatted number as per parameters
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
     * @memberof IntlUtils
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number, options) {
      var locales = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.REACT_APP_INTL_LOCALE;
      return new Intl.NumberFormat(locales, options).format(number);
    }
    /**
     * Extract the language part of the language code {lang-locale}, e.g. 'pt-BR'
     * becomes 'pt'.
     *
     * @static
     * @memberof IntlUtils
     *
     * @param {string} languageCode a language code, e.g. en-US
     * @returns {string} the language portion of the locale code e.g. en.
     */

  }, {
    key: "getLanguageFromLanguageCode",
    value: function getLanguageFromLanguageCode(languageCode) {
      var n = _indexOfInstanceProperty(languageCode).call(languageCode, '-');

      return languageCode.substring(0, n !== -1 ? n : languageCode.length);
    }
  }]);

  return IntlUtils;
}();

export { IntlUtils as default };